import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { InvoiceDemoData } from '../../../../../data/InvoiceDemoData';
import { useTemplate } from '../../../../features/template/TemplateProvider';
import useApi from '../../../../hook/useApi';

const InvoiceInfoContext = createContext();
export const useInvoiceInfo = () => useContext(InvoiceInfoContext);

function InvoiceInfoProvider({ children, id }) {
    const [headerLessPrint, setHeaderLessPrint] = useState(false);
    const [reloadKey, setReloadKey] = useState(0);
    const [invoiceInfo, setInvoiceInfo] = useState(InvoiceDemoData);
    const { setMessage } = useTemplate();
    const { get } = useApi();

    // -- Handle after print
    useEffect(() => {
        const handleAfterPrint = () => {
            setHeaderLessPrint(false);
        };
        window.addEventListener('afterprint', handleAfterPrint);

        return () => {
            window.removeEventListener('afterprint', handleAfterPrint);
        };
    }, []);

    // -- Load invoice info by invoiceId
    useEffect(() => {
        get(`/api/invoices/${id}`)
            .then(({ data, error, message }) => {
                if (error) {
                    throw new Error(message);
                }
                setInvoiceInfo(data);
            })
            .catch((err) => {
                setInvoiceInfo({});
                setMessage({ type: 'error', text: err?.message });
            });
    }, [id, reloadKey]);

    const value = useMemo(() => {
        // --Handle Reload
        const handleReload = () => {
            setReloadKey((d) => d + 1);
            setInvoiceInfo(InvoiceDemoData);
        };

        return {
            // Reload Key
            reloadKey,
            setReloadKey,
            // -- invoice info
            invoiceInfo,
            setInvoiceInfo,
            // -- Header less print
            headerLessPrint,
            setHeaderLessPrint,

            // All Handler
            handleReload
        };
    }, [invoiceInfo, headerLessPrint, reloadKey]);

    return <InvoiceInfoContext.Provider value={value}>{children}</InvoiceInfoContext.Provider>;
}

export default InvoiceInfoProvider;
